module.exports = __webpack_public_path__ + "static/media/pricing.cb48d483.svg";